import { render, staticRenderFns } from "./register.vue?vue&type=template&id=127f3996&scoped=true&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"
import style0 from "./register.vue?vue&type=style&index=0&id=127f3996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127f3996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/apps/bowling/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127f3996')) {
      api.createRecord('127f3996', component.options)
    } else {
      api.reload('127f3996', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=127f3996&scoped=true&", function () {
      api.rerender('127f3996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/register.vue"
export default component.exports